module.exports = {"title":"Control Display Schedule"}


//////////////////
// WEBPACK FOOTER
// ./src/language/en/controlDisplaySchedule.json
// module id = 1011
// module chunks = 10